import { render, staticRenderFns } from "./ProducerProducts.vue?vue&type=template&id=74e7fce6&scoped=true&"
import script from "./ProducerProducts.vue?vue&type=script&lang=js&"
export * from "./ProducerProducts.vue?vue&type=script&lang=js&"
import style0 from "./ProducerProducts.vue?vue&type=style&index=0&id=74e7fce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7fce6",
  null
  
)

export default component.exports